exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n    transition: .5s ease;\n}\n\na:hover img{\n    opacity: 0.5;\n}", ""]);

// exports
